<template>
    <Sheet v-loading="loading.actions['booking'] || loading.actions['timetable']">
        <el-divider>
           <span style="font-size:1.1rem;padding-right: 10px;">
                空教室查詢
            </span>
        </el-divider>
        <el-tabs value="vacancy">
            <el-tab-pane label="依空堂時間查詢" name="vacancy" lazy>
                <vacancy-room-query></vacancy-room-query>
            </el-tab-pane>

            <el-tab-pane label="依教室使用情況查詢" name="timetable" lazy >
                <timetable-query></timetable-query>
            </el-tab-pane>
        </el-tabs>
    </Sheet>
</template>

<script>
    import {mapState} from 'vuex';
    import TimetableQuery from './TimetableQuery';
    import VacancyRoomQuery from './VacancyRoomQuery';

    export default {
        name: 'UsageQuery',
        components:{
            TimetableQuery,
            VacancyRoomQuery
        },
        computed:{
            ...mapState(['loading']),
        },
    }
</script>

<style >

</style>